<!-- *NAVBAR* starts -->
<app-navbar *ngIf="!fullScreen" (seachTextEmpty)="checkNavbarSeachTextEmpty($event)"></app-navbar>
<!-- *NAVBAR* ends -->

<div class="wrapper" [ngClass]="{'show-overlay': !isNavbarSeachTextEmpty}" (click)="onWrapperClick();"
     (window:resize)="onResize($event)">

  <!-- *TOP* Menu starts -->
  <app-horizontal-menu appTopMenu *ngIf="menuPosition === 'Top' && !displayOverlayMenu"></app-horizontal-menu>
  <!-- *TOP* Menu ends -->

  <!-- *SIDE* Menu starts -->
  <div appSidebar *ngIf="(menuPosition === 'Side' || displayOverlayMenu) && !fullScreen"
       [ngClass]="{'main-menu': menuPosition === 'Side' || displayOverlayMenu, 'menu-fixed': menuPosition === 'Side' || displayOverlayMenu, 'menu-native-scroll': !perfectScrollbarEnable }"
       class="app-sidebar"
       (mouseenter)="sidebarMouseenter($event)" (mouseleave)="sidebarMouseleave($event)" data-active-color="white"
       [attr.data-background-color]="config?.layout.variant === 'Transparent' ? 'black': bgColor"
       [attr.data-image]="bgImage">
    <app-sidebar></app-sidebar>
    <div class="sidebar-background" [ngStyle]="{'background-image': 'url(' + bgImage + ')'}"
         *ngIf="config?.layout.sidebar.backgroundImage"></div>
  </div>


  <!-- *SIDE* Menu ends -->

  <div class="main-panel">
    <div class="main-content" [ngClass]="fullScreen ? 'no-margin' : ''">
      <div class="content-overlay"></div>
      <div class="content-wrapper">
        <div class="card m-0 bg-danger" *ngIf="showBanner">
          <div class="card-body body-padding">
            <div class="row">
              <div class="col-12 d-flex align-items-center justify-content-between">
                <p class="mb-0 d-flex align-items-center text-white" style="font-weight: 600;">
                  <span class="ft ft-alert-triangle mr-2"></span> {{ this.alert_Message }}
                </p>
                <button *ngIf="this.userData.auth.data.userType === 'Manager'" class="btn btn-dark ml-3"
                        [routerLink]="[this.dynamicUrl]"
                        style="white-space: nowrap;">Make Payment
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card m-0 bg-warning mt-2" *ngIf="this.show_releaseBanner">
          <div class="card-body body-padding">
            <div class="row">
              <div class="col-12 d-flex align-items-center justify-content-between">
                <p class="mb-0 d-flex align-items-center text-white" style="font-weight: 600;">
                          <span
                            class="ft ft-info mr-2"></span> {{ this.bannerData.description }}
                </p>
                <button (click)="onBannerClose()" class="action-btn p-2 ml-3"
                        style="white-space: nowrap;"><i class="ft ft-x text-white"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="card m-0 bg-danger mt-2" *ngIf="freeTrialExpire">
          <div class="card-body body-padding">
            <div class="row">
              <div class="col-12 d-flex align-items-center justify-content-between">
                <p class="mb-0 d-flex align-items-center text-white" style="font-weight: 600;">
                  <span class="ft ft-alert-triangle mr-2"></span>{{ this.expire_Message }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- FOOTER -->
    <app-footer></app-footer>
    <!-- Scroll to top button -->
    <button class="btn btn-primary scroll-top mb-4" type="button" *ngIf="isScrollTopVisible" (click)="scrollToTop()"><i
      class="ft-arrow-up"></i></button>
  </div>

  <!-- *NOTIFICATION-SIDEBAR* starts -->
  <app-notification-sidebar></app-notification-sidebar>
  <!-- *NOTIFICATION-SIDEBAR* ends -->

  <!-- *CUSTOMIZER* starts -->
  <!--  <app-customizer></app-customizer>-->
  <!-- *CUSTOMIZER* ends -->

  <div class="sidenav-overlay" (click)="onOutsideClick($event);"
       [ngClass]="{'d-none': displayOverlayMenu && hideSidebar && !overlayContent , 'd-block': displayOverlayMenu && !hideSidebar && overlayContent && innerWidth < 1200}"></div>
  <div class="drag-target"></div>
</div>
